<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ 'TASK.COMMENTS' | translate }}</h3>
    </div>
    <div class="card-toolbar">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="close($event)">
        <i class="flaticon2-cross icon-nm" style="padding: 0"></i>
      </button>
    </div>
  </div>
  <div class="form">
    <div class="card-body" style="padding: 0; overflow: hidden">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <div style="padding: 0">
        <div class="col-lg-12" style="padding: 0">
          <kt-comments
            [id]="transactionId"
            [type]="transactionType"
            [comments]="comments"
            [height]="height"
            (postedFirstComment)="postedFirstComment = true"
            [followup_id]="followupId"
            [taskTemplateId]="data?.task_template_id"
          ></kt-comments>
        </div>
      </div>
    </div>
  </div>
</div>
